import mediaQueries from "../design-tokens/mediaQueries";
// @ts-check

export const Breakpoints = /** @type {const} */ ({
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl"
});

export const breakpointValues = /** @type {const} */ ({
  [Breakpoints.sm]: 0, // No need to use media queries for small screens
  [Breakpoints.md]: parseInt(mediaQueries["medium-min"]),
  [Breakpoints.lg]: parseInt(mediaQueries["large-min"]),
  [Breakpoints.xl]: parseInt(mediaQueries["xlarge-min"])
});

/** @param {number} width */
export const getBreakpoint = (width) => {
  if (width >= breakpointValues.xl) {
    return Breakpoints.xl;
  }
  if (width >= breakpointValues.lg) {
    return Breakpoints.lg;
  }
  if (width >= breakpointValues.md) {
    return Breakpoints.md;
  }

  return Breakpoints.sm;
};

export const breakpointWeights = /** @type {const} */ ({
  [Breakpoints.sm]: 0,
  [Breakpoints.md]: 1,
  [Breakpoints.lg]: 2,
  [Breakpoints.xl]: 3
});

export const maxFontSizeMapForFullWidthText = /** @type {const} */ {
  [Breakpoints.sm]: 195,
  [Breakpoints.md]: 220,
  [Breakpoints.lg]: 410,
  [Breakpoints.xl]: 560
};

export const isSmallOrMediumBreakpoint = (screenWidth) => {
  const currentBreakpoint = getBreakpoint(screenWidth);
  return breakpointWeights[currentBreakpoint] < breakpointWeights.lg;
};
